import axios from "axiosConfig";

const sendForm = inputs => {
  return axios.post("api/demo_leads/", inputs);
};

const DemoService = {
  sendForm,
};

export default DemoService;
